import { render, staticRenderFns } from "./NsRegisterPrompt.vue?vue&type=template&id=6421383f&"
import script from "./NsRegisterPrompt.vue?vue&type=script&lang=js&"
export * from "./NsRegisterPrompt.vue?vue&type=script&lang=js&"
import style0 from "./NsRegisterPrompt.vue?vue&type=style&index=0&id=6421383f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports